import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import throttle from 'lodash/throttle';

import "./instrument";
import App from 'App';
import ls from 'helpers/localStorage';
import configureStore from './store/configureStore';
import './index.scss';

import "bootstrap/dist/js/bootstrap.bundle.min";

const store = configureStore();

// Write state to localStorage everytime the store updates
store.subscribe(
  throttle(() => {
    ls.saveState({
      appReducer: store.getState().appReducer,
    });
  }, 1000)
);

ReactDOM.render(
  React.createElement(App, { store }),
  document.getElementById('root')
);
